module.exports = __webpack_public_path__ + "static/media/จอ.76795d80.png";